import React, { useState, useEffect, useCallback } from "react";
import { assets } from "../../../Assets/assets";
import { icons } from "../../../Assets/Icons/icons";
import { useNavigate } from "react-router-dom";

const HomeHero = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  const homeBannerData = [
    {
      image: assets.homeProprty1,
      heading: "Find Your Place to Thrive",
      text: "Step into a home that's thoughtfully crafted to fit your lifestyle and inspire your dreams.",
    },
    {
      image: assets.homeProprty2,
      heading: "Designed for How You Live",
      text: "Experience the perfect blend of comfort, style, and functionality in your new home.",
    },
    {
      image: assets.homeProprty3,
      heading: "A Home that Truly Fits",
      text: "We build more than houses. We create personalized environments that adapt to your rhythm, your family, and your dreams.",
    },
  ];

  const nextSlide = useCallback(() => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev + 1) % homeBannerData.length);
    setTimeout(() => setIsAnimating(false), 1500);
  }, [isAnimating, homeBannerData.length]);

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide(
      (prev) => (prev - 1 + homeBannerData.length) % homeBannerData.length
    );
    setTimeout(() => setIsAnimating(false), 1500);
  };

  const goToSlide = (index) => {
    if (isAnimating || index === currentSlide) return;
    setIsAnimating(true);
    setCurrentSlide(index);
    setTimeout(() => setIsAnimating(false), 1500);
  };

  useEffect(() => {
    if (isAnimating) return;
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [nextSlide, isAnimating]);

  useEffect(() => {
    setHasLoaded(true);
  }, []);

  return (
    <section>
      <div className="relative overflow-hidden h-[90vh] w-full">
        {/* Slide container */}
        <div
          className="flex transition-transform duration-[1300ms] ease-in-out h-full"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {homeBannerData.map(({ image, heading, text }, index) => (
            <div
              key={index}
              className="relative flex-shrink-0 w-full h-full overflow-hidden"
            >
              {/* Background image */}
              <img
                className={`h-full w-full object-cover brightness-75 transition-transform duration-[5000ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${
                  index === currentSlide ? "scale-110" : "scale-100"
                }`}
                src={image}
                alt="property"
              />

              {/* Centered content */}
              <article
                className={`space-y-6 md:space-y-10 absolute inset-0 flex flex-col items-center justify-center text-center px-4 md:px-10 z-20 text-white transition-all duration-[1500ms] ease-[cubic-bezier(0.25,0.1,0.25,1)] ${
                  index === currentSlide
                    ? "opacity-100 translate-y-0 blur-0 scale-100"
                    : "opacity-0 translate-y-20 blur-md scale-95"
                } ${!hasLoaded && index === 0 ? "animate-initialFade" : ""}`}
              >
                <h1 className="lg:text-6xl text-4xl sm:text-5xl font-medium leading-tight tracking-tight drop-shadow-[0_4px_8px_rgba(0,0,0,0.6)] transition-all duration-700 delay-200 transform">
                  {heading}
                </h1>

                <p className="font-semibold xl:text-xl lg:text-lg sm:text-base text-white/90 drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)] mt-4 max-w-2xl transition-all duration-1000 delay-500">
                  {text}
                </p>

                <div
                  className={`flex items-center justify-center font-semibold gap-5 text-lg mt-8 transition-all duration-[1200ms] delay-[700ms] ${
                    index === currentSlide
                      ? "opacity-100 translate-y-0 blur-0 scale-100"
                      : "opacity-0 translate-y-12 blur-sm scale-95"
                  }`}
                >
                  <button
                    onClick={() => navigate("/contact")}
                    className="bg-white text-sm lg:text-base capitalize text-black hover:bg-[#E4E95B] transition-transform duration-300 lg:px-6 px-5 py-3 rounded-md hover:-translate-y-1 shadow-md"
                  >
                    contact us
                  </button>
                </div>
              </article>
            </div>
          ))}
        </div>

        {/* Arrows */}
        <div className="absolute hidden w-full left-0 top-1/2 -translate-y-1/2 xl:flex items-center justify-between px-5 z-30">
          <button
            onClick={prevSlide}
            className="bg-black/70 rounded-lg p-3 text-3xl text-white hover:bg-white/80 hover:text-black transition-all duration-300 cursor-pointer hover:scale-110 backdrop-blur-sm"
          >
            {icons.leftAngleIcon}
          </button>
          <button
            onClick={nextSlide}
            className="bg-black/70 rounded-lg p-3 text-3xl text-white hover:bg-white/80 hover:text-black transition-all duration-300 cursor-pointer hover:scale-110 backdrop-blur-sm"
          >
            {icons.rightAngleIcon}
          </button>
        </div>

        {/* Dots */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-30">
          {homeBannerData.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-4 h-4 rounded-full transition-all duration-300 border-2 border-white ${
                index === currentSlide
                  ? "bg-white scale-125"
                  : "bg-transparent hover:bg-white/50"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeHero;





// import React, { useState, useEffect, useCallback } from "react";
// import { assets } from "../../../Assets/assets";
// import { icons } from "../../../Assets/Icons/icons";
// import { useNavigate } from "react-router-dom";

// const HomeHero = () => {
//   const navigate = useNavigate();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [hasLoaded, setHasLoaded] = useState(false);

//   const homeBannerData = [
//     {
//       image: assets.homeProprty1,
//       heading: "Find Your Place to Thrive",
//       text: "Step into a home that's thoughtfully crafted to fit your lifestyle and inspire your dreams.",
//     },
//     {
//       image: assets.homeProprty2,
//       heading: "Designed for How You Live",
//       text: "Experience the perfect blend of comfort, style, and functionality in your new home.",
//     },
//     {
//       image: assets.homeProprty3,
//       heading: "A Home that Truly Fits",
//       text: "We build more than houses. We create personalized environments that adapt to your rhythm, your family, and your dreams",
//     },
//   ];

//   const nextSlide = useCallback(() => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setCurrentSlide((prev) => (prev + 1) % homeBannerData.length);
//     setTimeout(() => setIsAnimating(false), 1500);
//   }, [isAnimating, homeBannerData.length]);

//   const prevSlide = () => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setCurrentSlide(
//       (prev) => (prev - 1 + homeBannerData.length) % homeBannerData.length
//     );
//     setTimeout(() => setIsAnimating(false), 1500);
//   };

//   const goToSlide = (index) => {
//     if (isAnimating || index === currentSlide) return;
//     setIsAnimating(true);
//     setCurrentSlide(index);
//     setTimeout(() => setIsAnimating(false), 1500);
//   };

//   useEffect(() => {
//     if (isAnimating) return;
//     const interval = setInterval(() => {
//       nextSlide();
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [nextSlide, isAnimating]);

//   useEffect(() => {
//     setHasLoaded(true);
//   }, []);

//   return (
//     <section>
//       <div className="relative overflow-hidden h-[90vh] w-full">
//         <div
//           className="flex transition-transform duration-[1300ms] ease-in-out h-full"
//           style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//         >
//           {homeBannerData.map(({ image, heading, text }, index) => (
//             <div
//               key={index}
//               className="relative flex-shrink-0 w-full h-full overflow-hidden"
//             >
//               <img
//                 className={`h-full w-full object-cover brightness-75 transition-transform duration-[5000ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${
//                   index === currentSlide ? "scale-110" : "scale-100"
//                 }`}
//                 src={image}
//                 alt="property"
//               />

//               <article
//                 className={`absolute z-20 sm:top-[20%] top-[15%] md:w-[45%] w-[90%] xl:space-y-6 lg:space-y-5 space-y-4 left-[5%] text-white transition-all duration-[1500ms] ease-[cubic-bezier(0.25,0.1,0.25,1)] ${
//                   index === currentSlide
//                     ? "opacity-100 translate-y-0 blur-0 scale-100"
//                     : "opacity-0 translate-y-20 blur-md scale-95"
//                 } ${!hasLoaded && index === 0 ? "animate-initialFade" : ""}`}
//               >
//                 <h1 className="lg:text-6xl text-5xl font-medium leading-tight tracking-tight drop-shadow-[0_4px_8px_rgba(0,0,0,0.6)] transition-all duration-700 delay-200 transform">
//                   {heading}
//                 </h1>

//                 <p className="font-semibold xl:text-xl lg:text-lg sm:text-base leading-snug text-white/90 drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)] transition-all duration-1000 delay-500">
//                   {text}
//                 </p>

//                 <div
//                   className={`flex items-center font-semibold gap-5 text-lg transition-all duration-[1200ms] delay-[700ms] ${
//                     index === currentSlide
//                       ? "opacity-100 translate-y-0 blur-0 scale-100"
//                       : "opacity-0 translate-y-12 blur-sm scale-95"
//                   }`}
//                 >
//                   <button
//                     onClick={() => navigate("/contact")}
//                     className="bg-white text-sm lg:text-base capitalize text-black hover:bg-[#E4E95B] transition-transform duration-300 lg:px-6 px-5 py-3 rounded-md hover:-translate-y-1 shadow-md"
//                   >
//                     contact us
//                   </button>
//                 </div>
//               </article>
//             </div>
//           ))}
//         </div>

//         <div className="absolute hidden w-full left-0 top-[45%] xl:flex items-center justify-between px-5 z-30">
//           <button
//             onClick={prevSlide}
//             className="bg-black/70 rounded-lg p-3 text-3xl text-white hover:bg-white/80 hover:text-black transition-all duration-300 cursor-pointer hover:scale-110 backdrop-blur-sm"
//           >
//             {icons.leftAngleIcon}
//           </button>
//           <button
//             onClick={nextSlide}
//             className="bg-black/70 rounded-lg p-3 text-3xl text-white hover:bg-white/80 hover:text-black transition-all duration-300 cursor-pointer hover:scale-110 backdrop-blur-sm"
//           >
//             {icons.rightAngleIcon}
//           </button>
//         </div>

//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-30">
//           {homeBannerData.map((_, index) => (
//             <button
//               key={index}
//               onClick={() => goToSlide(index)}
//               className={`w-4 h-4 rounded-full transition-all duration-300 border-2 border-white ${
//                 index === currentSlide
//                   ? "bg-white scale-125"
//                   : "bg-transparent hover:bg-white/50"
//               }`}
//             />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HomeHero;
